import { anyPass, compose, complement, filter, map } from 'ramda'
import { RouteConfig } from 'vue-router'
import { router } from '@/router'
import { routes } from '@/router/routes'
import { hasChildren, getChildren, getFullPath } from '@/router/tools'
import { FilterFn } from '@/models/helpers/function'

const collapseInfos = {
  fold: { icon: 'el-icon-s-fold', text: '收起' },
  unfold: { icon: 'el-icon-s-unfold', text: '展开' }
}

export function chooseCollapseInfo(collapse: boolean) {
  return collapse ? collapseInfos.unfold : collapseInfos.fold
}

export function isHidden(route: RouteConfig) {
  return !!route.meta && !!route.meta.hidden
}

export function isSub(route: RouteConfig) {
  return !!route.children && !!route.children.length
}

export function chooseIcon(route: RouteConfig) {
  return route.meta && route.meta.icon ? route.meta.icon : 'el-icon-document'
}

export const filterRoutes: FilterFn<RouteConfig> = testFn => {
  const deep = (route: RouteConfig) => {
    const children = filterRoutes(testFn)(getChildren(route))
    return children.length ? { ...route, children } : route
  }

  return compose(filter(anyPass([hasChildren, testFn])), map(deep))
}

export function getRoutes() {
  return filterRoutes(complement(isHidden))(routes)
}

export function navTo(key: string) {
  if (key === router.currentRoute.meta!.key) return
  const path = getFullPath(key)
  router.push(path)
}
